// index.js or main.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js'; // Make sure the path is correct

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);


